<div class="section-container">
  <div class="flex-container">
    <div class="flex-item col1">
      <div class="flex-column">
        <img
          src="/assets/images/logo/logo-smarthead-turquoise.svg"
          title="SmartHead logo" />
      </div>
    </div>
    <div class="flex-item col2">
      <div class="flex-column">
        <a [href]="exploreLinkCreatorService.createStaticPageLink('about-us')">{{ 'footer.about' | transloco }}</a>
        <a [href]="exploreLinkCreatorService.createStaticPageLink('advisory-board')">{{ 'footer.advisory-board' | transloco }}</a>
        <a [href]="exploreLinkCreatorService.createStaticPageLink('contact')">{{ 'footer.contact' | transloco }}</a>
      </div>
    </div>
    <div class="flex-item col3">
      <div class="flex-column">
        <a href="https://docs.besmarthead.com/getting-started/introduction">{{ 'footer.smarthead-docs' | transloco }}</a>
        <a [routerLink]="routerLinkCreatorService.createMediaLink()">{{ 'footer.media' | transloco }}</a>
        <!-- patovina :/ -->
        <a class="empty-link"></a>
      </div>
    </div>
    <div class="flex-item col4">
      <div class="flex-column">
        <a [routerLink]="routerLinkCreatorService.createNewsFeedLink()">{{ 'footer.explore-companies-and-their-activities' | transloco }}</a>
      </div>
    </div>
    <div class="flex-item col5">
      <div class="flex-column">
        <a [href]="exploreLinkCreatorService.createStaticPageLink('pricing')">{{ 'footer.plans-and-pricing' | transloco }}</a>
        <a [href]="exploreLinkCreatorService.createStaticPageLink('become-a-partner')">{{ 'general.become-partner' | transloco }}</a>
        <a class="empty-link"></a>
      </div>
    </div>
    <div class="flex-item col6"></div>
  </div>
  <div class="footer-under-line-content">
    <span class="footer-under-line-left-content">
      <a class="copyright">© 2023 SmartHead Co.</a>
      <span
        class="version"
        *ngIf="isUserSHAdmin$ | async"
        >v{{ appVersion }}</span
      >
      <a
        class="terms-and-conditions"
        target="_blank"
        [href]="'https://files.besmarthead.com/documents/SmartHead_ToU_' + (termsOfUseLanguage$ | async) + '.pdf'"
        >{{ 'footer.terms' | transloco }}</a
      >
      <a
        class="policy-link"
        href="https://files.besmarthead.com/documents/SmartHead_Privacy_Policy_EN.pdf"
        target="_blank"
        >{{ 'footer.privacy-policy' | transloco }}</a
      >
      <a
        class="policy-link"
        [href]="exploreLinkCreatorService.createStaticPageLink('security-policy')"
        >{{ 'footer.security-policy' | transloco }}</a
      >
      <a
        class="footer-item cookies-policy"
        (click)="triggerCookieSettings()"
        >{{ 'cookie.title' | transloco }}</a
      >
    </span>
    <span class="footer-under-line-right-content">
      <a
        href="https://www.linkedin.com/company/smarthead-sisp/"
        (click)="onSocialLinkClick('SOCIAL_LINKEDIN_OPEN')">
        <ui-icon
          class="link-icon"
          key="linked-in"></ui-icon>
      </a>
      <a
        href="https://twitter.com/besmarthead"
        (click)="onSocialLinkClick('SOCIAL_TWITTER_OPEN')">
        <ui-icon
          class="link-icon"
          key="twitter"></ui-icon>
      </a>
      <a
        href="https://www.facebook.com/besmarthead"
        (click)="onSocialLinkClick('SOCIAL_FACEBOOK_OPEN')">
        <ui-icon
          class="link-icon"
          key="facebook"></ui-icon>
      </a>
      <a
        href="https://www.instagram.com/smarthead/"
        (click)="onSocialLinkClick('SOCIAL_INSTAGRAM_OPEN')">
        <ui-icon
          class="link-icon"
          key="instagram"></ui-icon>
      </a>
      <a
        href="https://www.youtube.com/channel/UCRV43cILDHuG-IN-VmqtqCg"
        (click)="onSocialLinkClick('SOCIAL_YOUTUBE_OPEN')">
        <ui-icon
          class="link-icon"
          key="youtube"></ui-icon>
      </a>
      <a
        href="https://www.besmarthead.com/profile/smarthead/1630"
        (click)="onSocialLinkClick('SOCIAL_SMARTHEAD_OPEN')">
        <ui-icon
          class="link-icon"
          key="smarthead"></ui-icon>
      </a>
    </span>
  </div>
</div>
